<div class="d-flex align-items-center">
    <button class="btn btn-light btn-sm border" [routerLink]="['../../']">
        <fa-icon [icon]="faChevronLeft" [size]="'lg'"></fa-icon>
    </button>
    <p class="h4 ms-2 mb-0">{{'Zoom_Integration' | translate}}</p>
</div>